import React, { useRef, useState, useEffect } from 'react'
import { styled } from '@material-ui/core/styles'
import { makeStyles } from '@material-ui/core/styles'
import { useGlobal } from '../../../../utils/useGlobal'
import * as firebase from '../../../../utils/firebase'
import * as Logger from '../../../../common/Logger'
import * as StringUtils from '../../../../common/StringUtils'
import * as DateUtils from '../../../../common/DateUtils'
import * as DataUtils from '../../../../common/DataUtils'
import * as Constants from '../../../../common/Constants'
import * as Navigator from '../../../../common/Navigator'
import * as Storage from '../../../../common/Storage'
import ProgressBar from '../../../widgets/ProgressBar'
import Strings from '../../../../common/Strings'
import IButton from '../../../controls/IButton'
import ITypography from '../../../controls/ITypography'
import ICard from '../../../controls/ICard'
import ICardContent from '../../../controls/ICardContent'
import AddIcon from '@material-ui/icons/Add'
import ToastView, { TOAST_ERROR, TOAST_SUCCESS } from '../../../widgets/ToastView'
import { createPropsWithActions, setLoading, showToast } from '../../../../common/ViewUtils'
import Styles from '../../../../common/Styles'
import moment from 'moment'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import SideCalendar from 'rc-calendar'
import { isMobile } from '../../../../common/ScreenUtils'

const AddButton = styled(IButton)({
  background: 'white',
  boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
  border: 0,
  borderRadius: 3,
  color: Styles.primaryBgColor,
  height: 35
})

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '100%',
    maxHeight: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.down('xs')]: {
      flexFlow: 'column'
    },
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    }
  },
  addButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  headerBox: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: 20,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 10,
    }
  },
  sideCalendar: {
    width: Styles.sideCalendar,
    [theme.breakpoints.up('sm')]: {
      marginLeft: 20,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 10,
    }
  }
}))

function ColumnCalendarView({ props }) {
  Logger.log('ColumnCalendarView')

  const { user } = useGlobal()
  const userId = user[Constants.USER_ID]
  const storeId = user[Constants.STORE_ID]
  const booking = Storage.getJson(Constants.BOOKING)
  const refItems = useRef([])
  const refTotal = useRef({})
  const refEvents = useRef([])
  const refDate = useRef(booking[Constants.DATE] ? moment(booking[Constants.DATE]) : moment())
  const [events, setEvents] = useState([])
  const [date, setDate] = useState(refDate.current)
  const [total, setTotal] = useState(0)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = () => {
    setLoading(props, true)
    const bDate = refDate.current
    const year = bDate.year()
    const month = bDate.month() + 1
    const path = `${year}/${month}`
    const httpsCallable = firebase.functions().httpsCallable(Constants.FB_FUNC_EMPLOYEE_BOOKINGS)
    httpsCallable({ userId, storeId, path }).then(({ data }) => {
      setLoading(props, false)
      var list = []
      refTotal.current = {}
      if (data.bookings) {
        for (let i in data.bookings) { // day
          const item1 = data.bookings[i]
          for (let j in item1) { // id
            const item2 = item1[j]
            item2[Constants.YEAR] = year
            item2[Constants.MONTH] = month
            item2[Constants.DAY] = i
            if (item2[Constants.EMPLOYEE] && item2[Constants.EMPLOYEE][Constants.ID] == user[Constants.ID]) {
              list.push(item2)
              const key = `${year}-${month}-${i}`
              refTotal.current[key] = refTotal.current[key] ? refTotal.current[key] + 1 : 1
            }
          }
        }
      }
      refItems.current = list
      filterData(refDate.current)

      if (props.onLoadedTotal) {
        props.onLoadedTotal(refTotal.current)
      }
      const key = `${refDate.current.year()}-${refDate.current.month() + 1}-${refDate.current.date()}`
      setTotal(refTotal.current[key] ?? 0)
    }).catch(err => {
      setLoading(props, false)
      showToast(props, TOAST_ERROR, err.message || Strings.errorLoadingData)
    })
  }

  const loadAvailableTimes = (date) => {
    let list = []
    const mobile = isMobile()
    // step 1: get all working hours in specific day
    const workingPeriods = user[Constants.WORKING_PERIOD] || []
    const workingOfflines = user[Constants.WORKING_OFFLINE] || []
    const day = date.format('dddd').toUpperCase()
    var offlinePair = [] // pair of hours [{start, end}]
    for (let i in workingOfflines) {
      const workingOffline = workingOfflines[i]
      const start = moment(workingOffline[Constants.START])
      if (date.isSame(start, 'day')) {
        const end = moment(workingOffline[Constants.END])
        var pair = {}
        pair[Constants.START] = DateUtils.getNumberFromHourMinute({ hour: start.hour(), minute: start.minute() })
        pair[Constants.END] = DateUtils.getNumberFromHourMinute({ hour: end.hour(), minute: end.minute() })
        offlinePair.push(pair)
      }
    }
    for (let i in workingPeriods) {
      const workingPeriod = workingPeriods[i]
      const dateNum = StringUtils.getNumber(workingPeriod[Constants.DATE_OF_WEEK])
      const dateStr = DateUtils.getDayByNumber(dateNum)
      if (day == dateStr && workingPeriod[Constants.IS_CHECK]) {
        const hours = workingPeriod[Constants.HOURS] || []
        for (let j in hours) {
          const item = hours[j]
          var pairs = [item]
          // check with offline hours, create new list that contains new pairs, 
          // e.g: working 8-11am, offline 9-10am => new list [8-9, 10-11]
          for (let k in offlinePair) {
            const offline = offlinePair[k]
            var subList = []
            for (let l in pairs) {
              const pair = pairs[l]
              if (DateUtils.isHourOverlap(pair[Constants.START], pair[Constants.END], offline[Constants.START], offline[Constants.END])) {
                subList.push(...DateUtils.splitHourOverlap(pair[Constants.START], pair[Constants.END], offline[Constants.START], offline[Constants.END]))
              } else {
                subList.push(pair)
              }
            }
            pairs = [...subList]
          }
          list.push(...pairs)
        }
        break
      }
    }
    if (list.length > 0) {
      // step 2: calculate available times for booking
      // using start and end of each pair, then plus with duration
      DataUtils.sortBy(list, Constants.START)
      var timesPair = [] // hold [pair]
      var pair = {} // hold {start, end}
      for (let i in list) {
        const item = list[i]
        if (i == 0) {
          pair[Constants.START] = item
          pair[Constants.END] = item
        } else {
          const previous = list[i - 1]
          if (item[Constants.START] == previous[Constants.END]) {
            pair[Constants.END] = item
          } else {
            timesPair.push(pair)
            pair = {}
            pair[Constants.START] = item
            pair[Constants.END] = item
          }
        }
      }
      timesPair.push(pair)
      const durationInMinutes = Constants.CALENDAR_TIME_STEP // step in calendar
      const duration = durationInMinutes / 60 // in hour      
      var availableTimes = []
      for (let i in timesPair) {
        const pair = timesPair[i]
        var start = pair[Constants.START][Constants.START]
        const end = pair[Constants.END][Constants.END]
        while (start + duration <= end) {
          var available = {}
          available[Constants.ID] = StringUtils.getUniqueID()
          available[Constants.DATE] = date
          available[Constants.START] = start
          available[Constants.END] = start + duration
          available[Constants.DISPLAY] = StringUtils.getHourFromNumber(start)

          var canSet = true
          const _end = available[Constants.END]
          // Condition 1: check with other booked services of user
          for (let i in refItems.current) {
            const item = refItems.current[i]
            const iDate = moment(item[Constants.DATE])
            const iStart = item[Constants.START]
            const iEnd = item[Constants.END]
            if (date.isSame(iDate, 'day') && user[Constants.ID] == item[Constants.EMPLOYEE][Constants.ID]
              && DateUtils.isHourOverlap(iStart, iEnd, start, _end)) {
              canSet = false
              break
            }
          }

          if (canSet) {
            availableTimes.push(available)
          }

          start += duration
        }
      }

      const path = date.year() + '/' + (date.month() + 1) + '/' + date.date()
      const now = moment()
      for (let i in availableTimes) {
        const item = availableTimes[i]
        const dStart = moment(item[Constants.DATE]).second(0)
        const dEnd = moment(item[Constants.DATE]).second(0)
        const startTime = DateUtils.getHourMinuteFromNumber(item[Constants.START])
        const endTime = DateUtils.getHourMinuteFromNumber(item[Constants.END])
        const dStartTime = dStart.hour(startTime.hour).minute(startTime.minute)
        const dEndTime = dEnd.hour(endTime.hour).minute(endTime.minute)

        // only select time that bigger than current time
        if (dStartTime.isBefore(now)) {
          continue
        }

        const event = {
          id: item[Constants.ID],
          title: '',
          start: dStartTime.toDate(),
          end: dEndTime.toDate(),
          resource: { hasEvent: false, path, className: mobile ? 'mobile-no-event' : 'no-event' }
        }
        refEvents.current.push(event)
      }
    }
  }

  const filterData = async (currentDate) => {
    refEvents.current = []

    for (let i in refItems.current) {
      const item = refItems.current[i]
      var date = moment(item[Constants.DATE])
      if (!currentDate.isSame(date, 'day')) {
        continue
      }
      var hourMinute = DateUtils.getHourMinuteFromNumber(item[Constants.START])
      const start = date.hour(hourMinute.hour).minute(hourMinute.minute)
      date = moment(item[Constants.DATE])
      hourMinute = DateUtils.getHourMinuteFromNumber(item[Constants.END])
      const end = date.hour(hourMinute.hour).minute(hourMinute.minute)
      const path = item[Constants.YEAR] + '/' + item[Constants.MONTH] + '/' + item[Constants.DAY] + '/' + item[Constants.ID]
      const event = {
        id: item[Constants.ID],
        title: `${item[Constants.USER][Constants.FIRST_NAME]} ${item[Constants.USER][Constants.LAST_NAME]} - ${item[Constants.SERVICE][Constants.TITLE]}`,
        start: start.toDate(),
        end: end.toDate(),
        resource: { hasEvent: true, path, className: 'has-event', style: { backgroundColor: item[Constants.SERVICE][Constants.COLOR] } }
      }
      refEvents.current.push(event)
    }

    // load available times for date that bigger than today
    if (currentDate.isSameOrAfter(moment(), 'day')) {
      loadAvailableTimes(currentDate)
    }

    //DateUtils.sortBy(refEvents.current, Constants.START)
    setEvents(refEvents.current)
  }

  const onInviteAppointment = () => {
    Navigator.navigate(props, Constants.PAGES_EMPLOYEE_INVITE_APPOINTMENT_INVITE_CUSTOMER)
  }

  const eventPropGetter = (event, start, end, isSelected) => {
    return { className: event.resource.className, style: event.resource.style }
  }

  const slotPropGetter = (date) => {
    return { style: { background: Constants.APPOINTMENT_TIME_SLOT_UNAVAILABLE_COLOR } }
  }

  const onSelectEvent = (event) => {
    const resource = event.resource
    if (!resource.hasEvent) {
      const startDate = moment(event.start)
      const hourMinute = { hour: startDate.hour(), minute: startDate.minute() }
      const hourNum = DateUtils.getNumberFromHourMinute(hourMinute) // convert to number       
      const booking = Storage.getJson(Constants.BOOKING)
      Storage.setItemToMemory(Constants.CACHE_BOOK_TIME, booking[Constants.DATE] + booking[Constants.START])
      booking[Constants.DATE] = startDate.toISOString()
      booking[Constants.START] = hourNum
      Storage.setJson(Constants.BOOKING, booking)
      Navigator.back()
    }
  }

  props.onClickDay = (value) => {
    // check to load new date
    if (!refDate.current.isSame(value, 'day')) {
      // check to load new appoiments for new month
      if (!refDate.current.isSame(value, 'month')) {
        refDate.current = value
        setDate(value)
        loadData()
      } else {
        refDate.current = value
        setDate(value)
        const key = `${value.year()}-${value.month() + 1}-${value.date()}`
        setTotal(refTotal.current[key] ?? 0)
        filterData(value)
      }
    }
  }

  const classes = useStyles()
  const localizer = momentLocalizer(moment)
  const calendarHeight = (Constants.CALENDAR_END_HOUR - Constants.CALENDAR_START_HOUR) * Constants.CALENDAR_TIME_SLOTS * Constants.CALENDAR_SLOT_HEIGHT

  return <>
    <div className={classes.headerBox}>
      <ITypography variant='h5' style={{ width: '100%' }}>{date.format('dddd, MMMM Do YYYY')}</ITypography>
    </div>
    <ITypography variant='body2'>{total} {total == 1 ? Strings.appointment : Strings.appointments}</ITypography>
    <Calendar
      formats={Constants.APPOINTMENT_FORMATS}
      date={date.toDate()}
      min={moment(date).hour(Constants.CALENDAR_START_HOUR).minute(Constants.CALENDAR_START_MINUTE).toDate()}
      max={moment(date).hour(Constants.CALENDAR_END_HOUR).minute(Constants.CALENDAR_END_MINUTE).toDate()}
      events={events}
      selectable={false}
      localizer={localizer}
      defaultView='day'
      toolbar={false}
      timeslots={Constants.CALENDAR_TIME_SLOTS}
      step={Constants.CALENDAR_TIME_STEP}
      onNavigate={() => { }}
      views={{ day: true }}
      style={{ height: calendarHeight || Styles.appointmentsHeight }}
      eventPropGetter={eventPropGetter}
      slotPropGetter={slotPropGetter}
      onSelectEvent={(event) => onSelectEvent(event)}
      onSelecting={slot => false}
    />
  </>
}

function SideCalendarView({ props }) {
  Logger.log('SideCalendarView')

  const { user } = useGlobal()
  const [date, setDate] = useState(moment())
  const [total, setTotal] = useState({})

  useEffect(() => {
    const booking = Storage.getJson(Constants.BOOKING)
    const chooseDate = booking[Constants.DATE] || moment()
    if (chooseDate) {
      onClickDay(moment(chooseDate))
    }
  }, [])

  const onClickDay = (value, fromUser) => {
    setDate(value)
    if (props.onClickDay) {
      props.onClickDay(value)
    }
  }

  const dateRender = (current, value) => {
    const key = `${current.year()}-${current.month() + 1}-${current.date()}`
    if (total[key] && total[key] > 0) {
      return <div className='rc-calendar-date' style={{ lineHeight: '10px', paddingTop: 5 }}>
        <span>{current.date()}</span>
        <div style={{ width: 4, height: 4, borderRadius: 2, background: 'red', margin: 'auto', marginTop: 2 }} />
      </div>
    }
    return <div className='rc-calendar-date' style={{ lineHeight: '10px', paddingTop: 5 }}>
      <span>{current.date()}</span>
    </div>
  }

  props.onLoadedTotal = (value) => {
    setTotal(value)
  }

  const classes = useStyles()

  return <SideCalendar showDateInput={false} value={date}
    onChange={(value) => onClickDay(value, true)}
    dateRender={(current, value) => dateRender(current, value)} />
}

function EmployeeViewTimes() {
  Logger.log(Constants.PAGES_EMPLOYEE_ADD_APPOINTMENT_VIEW_TIMES)

  let props = createPropsWithActions()
  const classes = useStyles()

  return <div className={classes.root}>
    <div style={{ width: '100%' }}>
      <ICard>
        <ICardContent>
          <ColumnCalendarView props={props} />
        </ICardContent>
      </ICard>
    </div>
    <div className={classes.sideCalendar}>
      <ICard>
        <ICardContent style={{ padding: 0 }}>
          <SideCalendarView props={props} />
        </ICardContent>
      </ICard>
    </div>
    <ProgressBar props={props} />
    <ToastView props={props} />
  </div>
}

export default EmployeeViewTimes